import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { PaymentPlan } from '../payments.models';
import { PlanCardComponent } from '../plan-card/plan-card.component';

@Component({
  selector: 'app-plan-grid',
  imports: [PlanCardComponent],
  templateUrl: './plan-grid.component.html',
  styleUrl: './plan-grid.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanGridComponent {
  readonly plans = input<PaymentPlan[]>([]);
  readonly disabled = input(false);
  readonly selected = output<PaymentPlan>();

  onSelected(plan: PaymentPlan): void {
    this.selected.emit(plan);
  }
}
